import React from 'react'

function About() {
  return (
    <div>
        <h2>Laptop For Start <span>Codeing</span></h2>
          <h2>Best <span>Laptop</span> For Starting </h2>
          
        <p>
          Hey are you wanna start coding?
          But you have low budget for starting your journy.
          Don't worry we are here for help you. We have some collection that maybe match with you budget.
          Happy learning.
        </p>
    </div>
  )
}

export default About;